import { render, staticRenderFns } from "./MachineLabels.vue?vue&type=template&id=2b48dcaf"
import script from "./MachineLabels.vue?vue&type=script&lang=js"
export * from "./MachineLabels.vue?vue&type=script&lang=js"
import style0 from "./MachineLabels.vue?vue&type=style&index=0&id=2b48dcaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports